import { global } from './global';

module.exports = {
    fulfilmentTimetable: {
        showTimesWhenAllowDecideLater: false,
        noAvailableTimesMessage:
        `You may be in an unserviced or remote area. Please contact our  <a href='${global.wowCustomerCareUrl}' onclick="utag.link({'event.Action':'click','event.Category':'Fulfilment Modal', 'event.Hash': Math.random(0, Number.MAX_VALUE).toString(36), 'event.Label': 'Non serviced address error', 'event.Name': 'Hyperlink_click', 'site.Section': 'shop:discover'});">Customer Care Team</a> for options. Alternatively you could choose pick up.`,
        deliveryTwoHourReservationMessage: 'Once you pick a window, we’ll reserve it for the next 2 hours. You may see some new Delivery options below, such as Partner Delivery. To find out more, <a href="https://www.woolworths.com.au/shop/discover/shopping-online/delivery" target="_blank">click here.</a> Happy shopping!',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/fulfilment-timetable.js